/* Enhance native disclosures on pointer desktops; click/keyboard remain usable
   without JavaScript and touch devices never rely on hover. */
(() => {
  const navigation = document.getElementById('site-navigation');
  if (!navigation) return;
  const groups = [...navigation.querySelectorAll('.nav-group')];
  const pointerDesktop = matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)');
  const closeOthers = current => groups.forEach(group => {
    if (group !== current) group.open = false;
  });
  groups.forEach(group => {
    let closeTimer;
    const summary = group.querySelector('summary');
    group.addEventListener('pointerenter', () => {
      clearTimeout(closeTimer);
      if (!pointerDesktop.matches) return;
      closeOthers(group);
      group.open = true;
    });
    group.addEventListener('pointerleave', () => {
      if (!pointerDesktop.matches) return;
      closeTimer = setTimeout(() => {
        if (!group.contains(document.activeElement)) group.open = false;
      }, 120);
    });
    summary?.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      closeOthers(group);
      group.open = true;
      group.querySelector('.nav-panel a')?.focus();
    });
    group.addEventListener('focusout', event => {
      // Touch browsers can blur the summary before dispatching a link's click.
      // Keep the panel in place so the tap can finish its native navigation.
      if (pointerDesktop.matches && !group.contains(event.relatedTarget)) group.open = false;
    });
  });
  document.addEventListener('click', event => {
    if (!navigation.contains(event.target)) closeOthers(null);
  });
  pointerDesktop.addEventListener('change', () => closeOthers(null));
})();
